import { useState, useEffect } from "react";

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Show install prompt
      setShowInstallPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      console.log("User accepted the install prompt");
    } else {
      console.log("User dismissed the install prompt");
    }

    // Clear the deferredPrompt
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
  };

  if (!showInstallPrompt) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: "80px",
        right: "16px",
        background: "#1a1a1a",
        border: "2px solid #FFD700",
        borderRadius: "8px",
        padding: "16px",
        maxWidth: "300px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
        zIndex: 9998
      }}
      data-testid="install-prompt"
    >
      <button
        onClick={handleDismiss}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          background: "transparent",
          border: "none",
          color: "#FFD700",
          fontSize: "20px",
          cursor: "pointer",
          padding: "0",
          width: "auto",
          margin: 0
        }}
        aria-label="Close"
      >
        ×
      </button>

      <h3 style={{ color: "#FFD700", marginBottom: "8px", fontSize: "1rem" }}>
        Install App
      </h3>
      <p style={{ color: "#eee", fontSize: "0.9rem", marginBottom: "12px" }}>
        Install Yisrael Learning Center for quick access and offline support.
      </p>
      <button
        onClick={handleInstallClick}
        data-testid="install-app-button"
        style={{
          background: "#FFD700",
          color: "#111",
          padding: "10px 20px",
          fontSize: "0.9rem",
          marginTop: 0
        }}
      >
        📱 Install Now
      </button>
    </div>
  );
}

export default InstallPrompt;
